import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import {AuthService} from '../../api/auth.service';
import {IMessage} from '../../marking/marking-chat.service';

interface IMessageSection {
  isEmoji: boolean;
  message: string;
}

@Component({
  selector: 'chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {
  MY_UID = 1;

  @Input() message: any;

  // public messageArray: IMessageSection[] = [];

  // private colonMatcher = '\\:(.*?)\\:'; // \:(.*?)\: ===> This is the best regex thus far

  constructor(
      public auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.MY_UID = this.auth.user().value.uid;
    // const arr = this.message.message.split(/:(.*?):/);

    /*
    let messageArray: IMessageSection[] = [];
    let wasLastEmoji = true;
    arr.forEach(s => {
      if (!!s && this.message.message.charAt(0) === ':') {
        wasLastEmoji = true;
        const newS = ':' + s + ':';
        messageArray.push({isEmoji: true, message: newS});
      } else if (!!s && !wasLastEmoji) {
        wasLastEmoji = true;
        const newS = ':' + s + ':';
        messageArray.push({isEmoji: true, message: newS});
      } else if (!!s) {
        wasLastEmoji = false;
        messageArray.push({isEmoji: false, message: s});
      }
    });
    this.messageArray = messageArray;
    */

  }

  formatMessageTime() {
    var elapsed = (new Date().getTime() - new Date(this.message.timestamp).getTime());
    if(elapsed / (1000) < 30) {
      return "now";
    }

    var mins = Math.round(elapsed / (1000 * 60));
    if(mins < 50) {
      return mins + " min ago";
    }

    var hrs = Math.round(elapsed / (1000 * 60 * 60));
    if(hrs < 20) {
      return hrs == 1 ? hrs + " hour ago" : hrs + " hours ago";
    }

    var days = Math.round(elapsed / (1000 * 60 * 60 * 24));
    return days == 1 ? days + " day ago" : days + " days ago";
  }

  linkify(inputText, who) {
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    let styleTag;
    if(who == 'me') {
      styleTag='style="font-weight:normal; text-decoration:underline"';
    }
    else {
      styleTag='style="font-weight:normal; text-decoration:underline; color:white;"';
    }

    if((inputText.includes('http') || inputText.includes('www')) && inputText.includes('exemplarSetID') && inputText.includes('exemplarID')) {
      let exemplarID = this.getParameterByName('exemplarID', inputText);

      //URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a data-testid="chat-message-exemplar-url" data-ui-name="Open exemplar link" '+styleTag+' href="$1" target="_blank">000REPLACETOKEN000</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a data-testid="chat-message-exemplar-web-address" data-ui-name="Open exemplar web address" '+styleTag+' href="http://$2" target="_blank">000REPLACETOKEN000</a>');

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
      replacedText = replacedText.replace(replacePattern3, '<a data-testid="chat-message-exemplar-email" data-ui-name="Email exemplar message contact" '+styleTag+' href="mailto:$1">$1</a>');

      replacedText = replacedText.replace('000REPLACETOKEN000', 'Exemplar #' + (parseInt(exemplarID)+1));

      if(!replacedText) {
        replacedText = inputText;
      }
    }
    else {
      //URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a data-testid="chat-message-url" data-ui-name="Open message link" '+styleTag+' href="$1" target="_blank">$1</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a data-testid="chat-message-web-address" data-ui-name="Open message web address" '+styleTag+' href="http://$2" target="_blank">$2</a>');

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
      replacedText = replacedText.replace(replacePattern3, '<a data-testid="chat-message-email" data-ui-name="Email message contact" '+styleTag+' href="mailto:$1">$1</a>');

      if(!replacedText) {
        replacedText = inputText;
      }
    }
  
    
    return replacedText;
  }

  getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

}
